import React, { useState } from 'react';
import styled from 'styled-components';
import { Title2 } from '../../../components/Typography';
import TextField from '@material-ui/core/TextField';
import Ratings from 'react-ratings-declarative';
import { PrimaryButton } from '../../../components/Buttons';
import { useDispatch } from 'react-redux';
import { sendReview } from '../orderStatusActions';
const Wrapper = styled.div`
  margin-top: 15px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

const TitleWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 10px;
  align-items: center;
`;

const Title = styled(Title2)`
  text-transform: uppercase;
  font-size: 16px;
`;

const DivCenter = styled.div`
  margin: auto;
`;

const Feedback = ({ orderId }) => {
  const dispatch = useDispatch();
  const [comment, setComment] = useState('');
  const [rating, setRating] = useState(0);
  const handleSendFeedback = () => {
    dispatch(sendReview(orderId, { comment, rating }));
  };
  return (
    <Wrapper>
      <TitleWrapper>
        <Title id='Feedback-RateYourOrder'>Tell us how we did today</Title>
      </TitleWrapper>
      <DivCenter>
        <Ratings
          id='Feedback-Ratings'
          rating={rating}
          widgetHoverColors='#f9d219'
          widgetRatedColors='#f9d219'
          changeRating={setRating}
        >
          <Ratings.Widget widgetDimension='30px' />
          <Ratings.Widget widgetDimension='30px' />
          <Ratings.Widget widgetDimension='30px' />
          <Ratings.Widget widgetDimension='30px' />
          <Ratings.Widget widgetDimension='30px' />
        </Ratings>
      </DivCenter>
      <div style={{ width: 300 }}>
        <TextField
          id='Feedback-CommentField'
          type='text'
          variant='outlined'
          multiline
          rows={4}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          fullWidth
        />
      </div>
      <DivCenter>
        <PrimaryButton
          id='Feedback-SendReviewButton'
          onClick={handleSendFeedback}
          disabled={!rating}
          buttonWidth='100px'
          buttonBorderRadius='15px'
          buttonHeight='35px'
        >
          Send
        </PrimaryButton>
      </DivCenter>
    </Wrapper>
  );
};

export default Feedback;
